import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

// import other components within the same project here

import Localization from "../Localization.jsx"

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  LinearProgress,
} from '@material-ui/core';

class ProgressDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      done: false,
      completed: 0,
      variant: "determinate",
      progressDescription: "",
      cancelCallback: null,
      doneCallback: null,
    };
    autoBind(this);

    if (this.props.description) {
      this.state.progressDescription = this.props.description;
    }
  }

  show(cancelCallback, doneCallback) {
    this.setState({
      open: true,
      done: false,
      variant: "determinate",
      cancelCallback: cancelCallback,
      doneCallback: doneCallback,
    });
    this.state.open = true;
    this.state.done = false;
    this.state.variant = "determinate";
    this.state.cancelCallback = cancelCallback;
    this.state.doneCallback = doneCallback;
    this.setProgress(0);
  }

  setVariant(value) {
    this.setState({ variant: value });
    this.state.variant = value;
  }

  setDescription(desc) {
    this.setState({ progressDescription: desc });
    this.state.progressDescription = desc;
  }

  setProgress(progress) {
    this.setState({ completed: progress });
    this.state.completed = progress;
  }

  handleCancelClicked() {
    if (this.state.cancelCallback) {
      this.state.cancelCallback();
    }
    this.handleClose();
  }

  handleClose() {
    this.setState({ open: false });
    this.state.open = false;
  }

  showDoneButton() {
    this.setState({ done: true });
    this.state.done = true;
  }

  handleDoneClicked() {
    if (this.state.doneCallback) {
      this.state.doneCallback();
    }
    this.handleClose();
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'sm'}
        >
          <DialogTitle>{Localization.strings.PROGRESS + " " + this.state.completed.toFixed(0) + "%"}</DialogTitle>
          <DialogContent>
            <DialogContentText style={{textAlign:'center'}}>
              {this.state.progressDescription}
            </DialogContentText>
            <LinearProgress variant={this.state.variant} value={this.state.completed} />
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <If condition={this.state.done}>
              <Then>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleDoneClicked}
                >
                  {Localization.strings.DONE}
                </Button>
              </Then>
              <Else>
                <Button onClick={this.handleCancelClicked}>{Localization.strings.CANCEL}</Button>
              </Else>
            </If>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default ProgressDialog;
